/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-lines */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
import PropTypes from 'prop-types';
import React from 'react';

import DatePicker from 'Component/DatePicker';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Form from 'Component/Form';
import Html from 'Component/Html';
import Image from 'Component/Image/Image.component';
import Popup from 'Component/Popup';
import SourceSubscription from 'Component/Subscription/Subscription.component';
import { SUBSCRIPTION_POPUP, SUBSCRIPTION_POPUP_FOOTER } from 'Component/Subscription/Subscription.config';
import SubscriptionQuery from 'Query/Subscription.query';
import { CustomerType } from 'Type/Account.type';
import { fetchMutation } from 'Util/Request';
import { VALIDATION_INPUT_TYPE, VALIDATION_RULES } from 'Util/Validator/Config';

import './SubscriptionBlockForm.style';

/** @namespace Scandipwa/Component/SubscriptionBlockForm/Component */
export class SubscriptionBlockFormComponent extends SourceSubscription {
    static propTypes = {
        subscriptionBlockHeading: PropTypes.string.isRequired,
        subscriptionBlockCta: PropTypes.string.isRequired,
        subscriptionBlockAdditional: PropTypes.string.isRequired,
        subscriptionBlockDisclaimer: PropTypes.string.isRequired,
        subscriptionBlockImage: PropTypes.string.isRequired,
        subscriptionBlockPromo: PropTypes.string.isRequired,
        isSignedIn: PropTypes.bool.isRequired,
        customer: CustomerType.isRequired,
        isJustPopup: PropTypes.bool,
        isFooter: PropTypes.bool.isRequired
    };

    static defaultProps = {
        isJustPopup: false
    };

    __construct(props) {
        super.__construct(props);

        this.state = {
            email: '',
            confirmationEmail: '',
            isConfirmation: false,
            isTermsAndConditionsAccepted: false,
            message: '',
            startedInputting: false,
            inputAccepted: false,
            date: '',
            isMale: false,
            isFemale: false,
            ageError: false,
            isSuccess: false
        };

        this.onPopupHide = this.onPopupHide.bind(this);
    }

    onPopupHide() {
        const { activeOverlay, isFooter } = this.props;

        if (activeOverlay !== (isFooter ? SUBSCRIPTION_POPUP_FOOTER : SUBSCRIPTION_POPUP)) {
            return;
        }

        this.setState({
            isConfirmation: false,
            message: '',
            isTermsAndConditionsAccepted: false,
            startedInputting: false,
            inputAccepted: false,
            isMale: false,
            isFemale: false,
            date: '',
            isSuccess: false
        });
    }

    calculateAge(dob1) {
        const today = new Date();
        const birthDate = new Date(dob1); // create a date object directly from `dob1` argument
        // eslint-disable-next-line fp/no-let
        let age_now = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }

        return age_now;
    }

    getDate = (date) => {
        const age = this.calculateAge(date);
        const minAge = 16;

        if (age < minAge) {
            this.setState({
                ageError: true
            });
        } else {
            this.setState({
                ageError: false
            });
        }

        this.setState({
            date
        });
    };

    subscribe(email, gender, dob = null, response) {
        const requestField = SubscriptionQuery.getSubscriptionGenderBirthdayQueary(email, gender, dob);
        const {
            customer = {},
            customer: { email: customerEmail },
            isSignedIn,
            updateCustomer
        } = this.props;

        fetchMutation(requestField).then(
            /** @namespace Scandipwa/Component/SubscriptionBlockForm/Component/SubscriptionBlockFormComponent/subscribe/fetchMutation/then */
            ({ addGenderBirthdateToSubscription }) => {
                if (isSignedIn && email === customerEmail) {
                    updateCustomer({ ...customer, is_subscribed: true });
                }

                response(addGenderBirthdateToSubscription);
            },
            /** @namespace Scandipwa/Component/SubscriptionBlockForm/Component/SubscriptionBlockFormComponent/subscribe/fetchMutation/then/catch */
            ([{ message }]) => {
                response(message);
            }
        );
    }

    getGender(isMale, isFemale) {
        if (isMale) {
            return 1;
        }

        if (isFemale) {
            return 2;
        }

        return null;
    }

    onSubmit = () => {
        const { isConfirmation } = this.state;
        const { toggleOverlayByKey, isFooter } = this.props;

        if (!isConfirmation) {
            this.setState({ isConfirmation: true });
            toggleOverlayByKey(isFooter ? SUBSCRIPTION_POPUP_FOOTER : SUBSCRIPTION_POPUP);
        }
    };

    onSubmitSuccess = () => {
        const {
            email,
            date,
            isMale,
            isFemale
        } = this.state;

        const gender = this.getGender(isMale, isFemale);

        if (email) {
            this.setState({ inputAccepted: true });
            this.subscribe(email, gender, date, (message) => {
                this.setState({
                    message
                });
                this.setState({
                    isSuccess: true
                });
            });
        }
    };

    onChangeMale = () => {
        const { isMale } = this.state;

        this.setState({
            isMale: !isMale,
            isFemale: false
        });
    };

    onChangeFemale = () => {
        const { isFemale } = this.state;

        this.setState({
            isFemale: !isFemale,
            isMale: false
        });
    };

    renderPopup() {
        const { message } = this.state;
        const { isFooter } = this.props;

        return (
            <Popup
              id={ isFooter ? SUBSCRIPTION_POPUP_FOOTER : SUBSCRIPTION_POPUP }
              title="bbb"
              mix={ { block: 'Subscription', elem: 'Popup' } }
              onHide={ this.onPopupHide }
            >
                <div block="Subscription" elem="Logo" />
                { message !== '' ? this.renderMessage(message) : this.renderForm() }
            </Popup>
        );
    }

    renderForm() {
        const {
            subscriptionBlockHeading,
            subscriptionBlockCta,
            subscriptionBlockAdditional,
            subscriptionBlockDisclaimer,
            subscriptionBlockImage,
            subscriptionBlockPromo,
            secure_base_media_url
        } = this.props;

        const {
            email,
            isTermsAndConditionsAccepted,
            confirmationEmail,
            startedInputting,
            inputAccepted,
            isMale,
            isFemale,
            ageError
        } = this.state;

        const errorMessage = this.getErrorMessage(email, confirmationEmail);
        const disableSubmit = email.length === 0
            || !isTermsAndConditionsAccepted
            || inputAccepted
            || (!isMale && !isFemale)
            || ageError;

        return (
            <div
              block="SubscriptionBlock"
              elem="Popup"
            >
                <Image
                  block="SubscriptionBlock"
                  elem="Image"
                  src={ `${ secure_base_media_url }subscriber-block\\${ subscriptionBlockImage }` }
                  alt="Block image"
                />
                <Form
                  onSubmit={ this.onSubmitSuccess }
                >
                    <div block="SubscriptionBlock" elem="FieldWrapper" mods={ { isValid: errorMessage === '' } }>
                        <div block="UpperTitle">
                            <p
                              block="Popup"
                              elem="Title"
                            >
                                <Html content={ subscriptionBlockHeading } />
                            </p>
                        </div>
                        <div
                          block="SubscriptionBlock"
                          elem="PromoBlock"
                        >
                            <p
                              block="SubscriptionBlock"
                              elem="PromoContent"
                            >
                                <Html content={ subscriptionBlockPromo } />
                            </p>
                        </div>
                        <div block="Form">
                            <div
                              block="Fields"
                            >
                                <Field
                                  type={ FIELD_TYPE.email }
                                  label={ __('Email') }
                                  attr={ {
                                      id: 'subscription_email',
                                      name: 'email',
                                      autoComplete: 'off',
                                      defaultValue: email
                                  } }
                                  events={ {
                                      onChange: this.onChange
                                  } }
                                  validationRule={ {
                                      isRequired: true,
                                      inputType: VALIDATION_INPUT_TYPE.email
                                  } }
                                  validateOn={ ['onSubmit'] }
                                />
                            </div>
                        </div>
                    </div>
                    <div block="Subscription" elem="CustomError" mods={ { isVisible: startedInputting } }>
                       { errorMessage }
                    </div>
                    <div
                      block="SubscriptionBlock"
                      elem="Gender"
                    >
                        <div
                          block="SubscriptionBlock"
                          elem="GenderSelect"
                        >
                            { __('Buying preference') }
                        </div>
                        <div
                          block="SubscriptionBlock"
                          elem="GenderCheckboxes"
                        >
                            <Field
                              type={ FIELD_TYPE.checkbox }
                              attr={ {
                                  id: 'genderMale',
                                  name: 'genderMale',
                                  value: '1',
                                  checked: isMale
                              } }
                              events={ {
                                  onChange: this.onChangeMale
                              } }
                              mix={ {
                                  block: 'SubscriptionBlock',
                                  elem: 'GenderField'
                              } }
                            />
                            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                            <label
                              block="SubscriptionBlock"
                              elem="GenderLabel"
                              htmlFor="genderMale"
                            >
                                { __('Male') }
                            </label>
                            <Field
                              type={ FIELD_TYPE.checkbox }
                              attr={ {
                                  id: 'gender_female',
                                  name: 'gender_female',
                                  value: '2',
                                  checked: isFemale
                              } }
                              events={ {
                                  onChange: this.onChangeFemale
                              } }
                              mix={ {
                                  block: 'SubscriptionBlock',
                                  elem: 'GenderField'
                              } }
                            />
                            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                            <label
                              block="SubscriptionBlock"
                              elem="GenderLabel"
                              htmlFor="genderFemale"
                            >
                                { __('Female') }
                            </label>
                        </div>
                    </div>
                    <div
                      block="SubscriptionBlock"
                      elem="DatePickerBlock"
                    >
                        <label
                          htmlFor="DatePicker"
                        >
                            { __('Birthday') }
                            <br />
                            <span>{ __('(optional)') }</span>
                        </label>
                        <DatePicker
                          getDate={ this.getDate }
                        />
                    </div>
                    <div block="Subscription" elem="CustomError" mods={ { isVisible: ageError } }>
                        { __('You must be at least 16 years old.') }
                    </div>
                    <div block="SubscriptionBlock" elem="Disclaimer">
                        <Field
                          type={ FIELD_TYPE.checkbox }
                          attr={ {
                              id: 'subscription_conditions',
                              name: 'subscription_conditions',
                              value: 'subscriptionConditions',
                              checked: isTermsAndConditionsAccepted
                          } }
                          events={ {
                              onChange: this.setTACAccepted
                          } }
                          mix={ {
                              block: 'SubscriptionBlock',
                              elem: 'TermsAndConditions',
                              mods: { isChecked: isTermsAndConditionsAccepted }
                          } }
                        />
                        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                        <label
                          block="SubscriptionBlock"
                          elem="DisclaimerLabel"
                          htmlFor="subscriptionConditions"
                        >
                            <Html content={ subscriptionBlockDisclaimer } />
                        </label>
                    </div>
                    <br />
                    <div block="SubscriptionBlock" elem="DisclaimerRequire">
                        <p>
                            { __('Required field') }
                        </p>
                    </div>
                    <div block="SubscriptionBlock" elem="Additional">
                        <Html content={ subscriptionBlockAdditional } />
                    </div>
                    <div block="SubscriptionBlock" elem="Cta">
                        <button
                          type="submit"
                          disabled={ disableSubmit }
                          mix={ { block: 'Button', elem: 'AddToCart' } }
                        >
                            <Html content={ subscriptionBlockCta } />
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderMessage(message) {
        return (
            <>
                <div block="Icon" elem="Puma" />
                <div block="SubscriptionBlock" elem="Message">
                    { message }
                </div>
            </>
        );
    }

    renderBlock() {
        const { message, isSuccess } = this.state;
        const { isFooter } = this.props;

        return (
            <Popup
              id={ isFooter ? SUBSCRIPTION_POPUP_FOOTER : SUBSCRIPTION_POPUP }
              block="SubscriptionBlockNonRegister"
              elem="Form"
              onHide={ this.onPopupHide }
              mix={ {
                  block: 'SubscriptionBlockNonRegister',
                  elem: 'Form',
                  mods: { isSuccess }
              } }
            >
                <div
                  block="SubscriptionBlock"
                  elem="Form"
                >
                    { message !== '' ? this.renderMessage(message) : this.renderForm() }
                </div>
            </Popup>
        );
    }

    onChange = (field) => {
        const { target: { value = '' } } = field;
        this.setState({ email: value });
    };

    render() {
        const { email } = this.state;
        const { isJustPopup, subscribeEmailRef } = this.props;

        if (isJustPopup) {
            return this.renderBlock();
        }

        return (
            <div block="Subscription">
                <div block="Subscription" elem="Title">
                    { __('Email Sign Up') }
                </div>
                <Form
                  onSubmit={ this.onSubmit }
                  mix={ { block: 'Subscription', elem: 'Form' } }
                >
                    <Field
                      type={ FIELD_TYPE.email }
                      attr={ {
                          id: 'subscription_email',
                          name: 'email',
                          defaultValue: email,
                          autoComplete: 'off',
                          placeholder: __('Email')
                      } }
                      elemRef={ subscribeEmailRef }
                      events={ {
                          onChange: this.onChange
                      } }
                      validationRule={ {
                          isRequired: true,
                          inputType: VALIDATION_INPUT_TYPE.email
                      } }
                      validateOn={ ['onChange'] }
                    />
                    <button
                      block="Subscription"
                      elem="Submit"
                      type="submit"
                      disabled={ !email || !email.match(VALIDATION_RULES.email) }
                      aria-label={ __('Submit') }
                    />
                </Form>
                { this.renderBlock() }
            </div>
        );
    }
}

export default SubscriptionBlockFormComponent;
